<template>
  <v-card tile>
    <v-card-title>ルビ変換結果</v-card-title>
    <v-divider />
    <v-card-subtitle
      class="mx-5 mt-2 pa-2"
      style="background-color: var(--v-background3-base);"
    >
      <p style="font-size: 13px;color: var(--v-textcolor-base);font-weight: bold;">
        変換した結果を保存
      </p>
      <v-btn
        class="ma-2"
        color="secondary"
        elevation="0"
        small
        tile
        @click="copyToNovel()"
      >
        アプリ内の他の小説にコピー
      </v-btn>
      <v-btn
        class="ma-2"
        color="secondary"
        elevation="0"
        small
        tile
        @click="downloadConverted()"
      >
        txtファイルをダウンロード
      </v-btn>
      <v-btn
        class="ma-2"
        color="secondary"
        elevation="0"
        small
        tile
        @click="copyClipboard()"
      >
        クリップボードにコピー
      </v-btn>
      <p
        v-if="copied"
        style="color:red;margin-left:12px;font-size:13px;"
      >
        クリップボードにコピーしました。
      </p>
    </v-card-subtitle>
    <v-card-text class="mt-4">
      <div
        id="converted"
        :class="'pa-2 linespace'+lineSpaceSize"
        :style="`background-color: var(--v-background3-base);font-size:${fontSize};white-space: pre-wrap;word-wrap:break-word`"
      >
        {{ converted }}
      </div>
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="secondary"
        elevation="0"
        style="border-radius: 0px"
        tile
        @click="close"
      >
        閉じる
      </v-btn>
    </v-card-actions>

    <v-dialog
      :value="selectNovelDialog"
      max-width="790"
      scrollable
    >
      <v-card>
        <v-card-title>
          コピー先小説選択
        </v-card-title>
        <v-divider />
        <v-card-text>
          <p class="mt-4">
            ※変換先のルビ形式のサイト【{{ toSiteType.label }}】に対応する小説のみを表示しています
          </p>
          <p class="mt-4 mb-0">
            保存先小説
          </p>
          <v-card-actions class="mt-0 pt-0">
            <v-select
              v-model="selectNovel"
              :items="targetNovels"
              class="hide-details mr-4"
              filled
              item-text="name"
              return-object
            />
            <v-btn
              color="secondary"
              elevation="0"
              height="60"
              max-height="60"
              style="border-radius: 8px;font-size: 16px;font-weight: bold;"
              @click="createNovelName=null;createNovelDialog=true"
            >
              <v-img
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/plus_w.png"
              />
            </v-btn>
          </v-card-actions>

          <p class="mt-4  mb-0">
            保存先フォルダ
          </p>
          <v-card-actions class="mt-0 pt-0">
            <v-select
              v-model="selectFolder"
              :disabled="!selectNovel"
              :items="targetFolders"
              class="hide-details mr-4"
              filled
              item-text="name"
              return-object
            />
            <v-btn
              :disabled="!selectNovel"
              color="secondary"
              elevation="0"
              height="60"
              max-height="60"
              style="border-radius: 8px;font-size: 16px;font-weight: bold;"
              @click="createFolderName=null;createFolderlDialog=true"
            >
              <v-img
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/plus_w.png"
              />
            </v-btn>
          </v-card-actions>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="selectNovelDialog=false"
          >
            キャンセル
          </v-btn>
          <v-btn
            :disabled="!selectNovel"
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="save()"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="createNovelDialog"
      max-width="790"
    >
      <v-card>
        <v-card-title>
          小説の作成
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-4">
          <v-text-field
            v-model="createNovelName"
            filled
            label="小説のタイトル"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="createNovelDialog=false"
          >
            キャンセル
          </v-btn>
          <v-btn
            :disabled="!createNovelName"
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="createNovel()"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="createFolderlDialog"
      max-width="790"
    >
      <v-card>
        <v-card-title>
          フォルダの作成
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-4">
          <v-text-field
            v-model="createFolderName"
            filled
            label="フォルダ名"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="createFolderlDialog=false"
          >
            キャンセル
          </v-btn>
          <v-btn
            :disabled="!createFolderName"
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="createFolder()"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert
      v-if="success"
      dense
      text
      type="success"
    >
      保存が完了しました。
    </v-alert>
  </v-card>
</template>

<script>
import {mapState} from "vuex";
import firebase from "firebase/app";
import axios from "axios";
import config from "@/const";
import rubiConverter from "@/component/rubiConverter";
export default {
  name: "ConvertRubi",
  components: {},
  props: ["toSiteType", "fromSiteType", "id", "close", ],
  data() {
    return {
      converted: "",
      copied: false,
      selectNovelDialog: false,
      targetNovels: [],
      selectNovel: null,
      targetFolders: [],
      selectFolder: null,
      createNovelDialog: false,
      createFolderlDialog: false,
      createNovelName: null,
      createFolderName: null,
      success: false,
      title:"",
      text:""
    }
  },
  computed: {
    ...mapState({
      fontSize: state => state.userModule.user.writerFontSizeTypeKeyValue.size * 13,
      lineSpaceSize: state => state.userModule.user.writerLineSpaceTypeKeyValue.value,
      novels: state => state.NovelListModule.NovelList
    })
  },
  watch: {
    toSiteType: {
      handler() {
        this.targetNovels = this.novels.filter(item => item.targetSite == this.toSiteType.value)
        this.selectFolder = null
        this.selectNovel = null
        this.targetFolders = []
        this.converted =rubiConverter.convert(this.fromSiteType.value,this.toSiteType.value,this.text)
      }, immediate: true
    },
    selectNovel: {
      async handler() {
        if (this.selectNovel == null)
          return
        const user = firebase.auth().currentUser
        const token = await user.getIdToken(false)
        if (token == null) {
          return
        }
        let ret = await axios.get(config.API_URL + "auth/folders", {
          headers: {"X-Firebase-Auth": token},
          params: {
            "novelId": this.selectNovel.id
          },
          data: {}
        })

        this.targetFolders = ret.data
        this.targetFolders.unshift({id: -1, name: "最上位（フォルダ選択なし）",})
      }
    },
    id:{
      async handler(){
        const user = firebase.auth().currentUser;
        const token = await user.getIdToken(false);
        const ret = await axios.get(config.API_URL + "auth/page", {
          headers: {"X-Firebase-Auth": token},
          params: {
            "id": this.id
          },
          data: {}
        });
        const item = ret.data;
        this.title=item.name;
        this.text=item.content;

      }, immediate: true
    },
    text:{
      handler(){
        this.converted =rubiConverter.convert(this.fromSiteType.value,this.toSiteType.value,this.text)
      },immediate:true
    }
  },
  mounted() {
    this.selectFolder = null
    this.selectNovel = null
  },
  methods: {
    createRubiFormat(siteConfig) {
      return `${siteConfig.rubiFormat.prefix}ルビ${siteConfig.rubiFormat.middle}ルビ${siteConfig.rubiFormat.suffix}`
    },
    copyToNovel() {
      this.selectNovelDialog = true
    },
    async save() {
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      let saveData = {
        createdDate: Date.now(),
        novelId: this.selectNovel.id,
        folderId: this.selectFolder ? this.selectFolder.id : -1
      }
      saveData.modifiedTimestamp = Date.now()
      saveData.updateDate = Date.now()
      saveData.name = this.title
      saveData.content = this.converted
      axios.post(config.API_URL + "auth/page", saveData, {
        headers: {"X-Firebase-Auth": token, "fromWeb": true},
      }).then(value => {
        this.success = true
        this.selectNovelDialog = false
      }).catch(reason => {
        alert("保存中にエラーが発生しました。もう一度保存してください")
      });
    },
    async createNovel() {
      const ret = await this.$store.dispatch("NovelListModule/save", {
        title: this.createNovelName,
        siteType: this.toSiteType.value
      })
      this.targetNovels.push(ret)
      this.createNovelDialog = false
    },
    downloadConverted() {
      const fileName = `${this.title ? this.title : 'タイトル無し'}.txt`;
      const blob = new Blob([this.converted], {'type': 'text/plain'});
      const isSaveBlob = window.navigator.msSaveBlob !== undefined;
      if (isSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName);
        return;
      }
      const tempAnchor = document.createElement('a');
      tempAnchor.href = URL.createObjectURL(blob);
      tempAnchor.setAttribute('download', fileName);
      tempAnchor.dispatchEvent(new MouseEvent('click'));
    },
    copyClipboard() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.converted);
        this.copied = true
      }
    },
    async createFolder() {
      let newData = {
        name: this.createFolderName,
        novelId: this.selectNovel.id,
        createdDate: Date.now(),
        folderId: -1
      }
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      newData.updateDate = Date.now()
      if (newData.createdDate == undefined) {
        newData.createdDate = Date.now()
      }
      newData.modifiedTimestamp = Date.now()
      axios.post(config.API_URL + "auth/folder", newData, {
        headers: {"X-Firebase-Auth": token, "fromWeb": true},
      }).then(
          value => {
            this.targetFolders.push(value.data)
            this.createFolderlDialog = false
          }
      ).catch(reason => {
        alert("データ更新に失敗しました。再度お試しください")
      })
    }
  }
}
</script>

<style scoped>

</style>